<template>
  <div class="top">
    <div class="tops">
       <div class="top01">
         <span v-if="!userinfo">欢迎您来到，启程志愿精准填报系统</span>
         <span v-if="userinfo" style="display: flex;">欢迎您，{{userinfo.nickname || userinfo.username}}
              <div v-if="userinfo.zhiyuan" @click="zhineng()" style="cursor: pointer;margin-left: 30px;text-decoration: underline;color: #2AA38B;">
                  {{userinfo.zhiyuan.score}}分、{{userinfo.zhiyuan.batch}}、{{userinfo.zhiyuan.group_d}}、{{userinfo.zhiyuan.subject}}
              </div>
        </span>
       </div>
       <div class="top02">
           <el-button type="text" v-if="!userinfo" @click="login">
             <span style="color: #515151;font-size: 14px;font-weight: normal;">登录</span>
           </el-button>
           <el-button type="text" style="margin-left: 20px;" v-if="!userinfo" @click="login">
             <span style="color: #515151;font-size: 14px;font-weight: normal;">注册</span>
           </el-button>
           <el-button type="text" style="margin-left: 20px;" v-if="userinfo" @click="shouye">
             <span style="color: #515151;font-size: 14px;font-weight: normal;">首页</span>
           </el-button>
           <!-- <el-button type="text" style="margin-left: 20px;" v-if="userinfo" @click="zonghe">
             <span style="color: #515151;font-size: 14px;font-weight: normal;">综合查询</span>
           </el-button> -->
           <el-button type="text" style="margin-left: 20px;" v-if="userinfo" @click="homeClick">
             <span style="color: #515151;font-size: 14px;font-weight: normal;">{{userinfo.role==3?"代理中心":"会员中心"}}</span>
           </el-button>
           <el-button type="text" style="margin-left: 20px;" @click="logut" v-if="userinfo">
             <span style="color: red;font-size: 14px;font-weight: normal;">退出登录</span>
           </el-button>
       </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  export default {
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    data(){
      return{

      }
    },
    mounted(){
        // if(localStorage.getItem("qichengUserToken")){
        //   console.log("login4")
        //   this.$store.dispatch("getUserInfo");
        // }
    },
    methods:{
      //登录
    login(){
      this.$store.dispatch("set_isLogin",true)
    },
      //退出登录
      logut(){
          this.$confirm('确认退出登录吗?', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
           }).then(()=>{
             localStorage.removeItem("qichengUserToken",null)
             this.$store.commit("setUserInfo",null);
           })
      },
      //个人中心
      homeClick(){
        this.$router.push({
          path:"/Home"
        })
      },
      shouye(){
        this.$router.push({
          path:"/"
        })
      },
      zonghe(){
        const routerUrl = this.$router.resolve({
          path:"/comprehensive"
        })
        window.open(routerUrl.href,"_blank")
      },
          //智能填报
    zhineng(){
      if(!this.userinfo){
        this.$store.dispatch("set_isLogin",true)
        return;
      }
      this.$router.push({
        path:"/Volunteer"
      })
    },
    },
  }
</script>

<style lang="scss" scoped>
  .top{
    width: 100%;
    height: 42px;
    background: #F3F4F7;
    .top02{
      margin-left: auto;
      display: flex;
      align-items: center;
      color: #515151;
      font-size: 14px;
    }
    .top01{
      color: #515151;
      font-size: 12px;
    }
    .tops{
      width: 1250px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue